// extracted by mini-css-extract-plugin
export var standaloneTable = "_gv-0";
export var standaloneTableWithBodyFill = "_gv-1";
export var withExtraHeader = "_gv-2";